import axios from "axios";
//import { resetToken, setToken } from "../redux/reducers/auth.slice";
import { store } from "../redux/store";
import { resetToken, setToken } from "../redux/slice/auth.slice";

export const setAuthHeader = (token: string): void => {
  if (token) {
    axios.defaults.headers.common["Authorisation"] = token;
    store.dispatch(setToken(token));
  } else {
    delete axios.defaults.headers.common["Authorisation"];
    store.dispatch(resetToken());
  }
};

